// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__HhDv8","spin":"spinner_spin__1stUk"};